export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colunas disputadas"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reiniciar"])}
}